/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const MIN_MAX_ACR = {
    DOOR_HELD_OPEN_DELAY: { start: 4, end: 15 },
    KEEP_OPEN: { start: 5 }
}

export const ACR_MODEL = {
    zoneId: null,
    controllerId: null,
    hidSioId: null,
    entryReaderId: null,
    entryOutputId: null,
    rexInputId: null,
    doorInputId: null,

    enableExitConfig: false,
    exitReaderId: null,
    doorHeldOpenDelay: null,
    keepOpen: null,
    toAddEdit: function () {
        return {
            zoneId: this.zoneId,
            hidSioId: this.hidSioId,
            // The entry reader is optional, so the "no selection" option is sent as null
            entryReaderId: this.entryReaderId || null,
            entryOutputId: this.entryOutputId,
            exitReaderId: this.exitReaderId,
            // The exit output and exit input are no longer set from the form
            exitOutputId: null,
            exitInputId: null,
            // The REX and door inputs are optional, so the "no selection" option is sent as null
            rexInputId: this.rexInputId || null,
            doorInputId: this.doorInputId || null,
            doorHeldOpenDelay: this.doorHeldOpenDelay,
            keepOpen: parseInt(this.keepOpen)
        }
    },
    isValid: function () {
        return  this.zoneId !== null &&
        this.hidSioId !== null &&
        this.entryOutputId !== null &&
        this.doorHeldOpenDelay !== null &&
        this.keepOpen !== null && this.keepOpen !== '' &&
        this.isValidKeepOpen() &&
        (!this.enableExitConfig || this.exitReaderId !== null);
    },
    // How long the door is kept open, in seconds; an empty value is flagged as missing instead
    isValidKeepOpen: function () {
        if (this.keepOpen === null || this.keepOpen === '') return true;
        const keepOpen = parseInt(this.keepOpen, 10);
        return !isNaN(keepOpen) && keepOpen >= MIN_MAX_ACR.KEEP_OPEN.start;
    },
    setToTable: function (data, sioName) {
        return {
            id: data.id,
            hidSioId: data.hidSioId,
            hidSioName: sioName,
            zoneName: data.zoneName,
            entryReaderName: data.entryReaderName,
            entryOutputName: data.entryOutputName,
            exitReaderName: data.exitReaderName,
            keepOpen: data.keepOpen
        };
    }
};
